export var Action;
(function (Action) {
    Action["WriteCart"] = "writeCart";
    Action["ChangeItem"] = "changeItem";
})(Action || (Action = {}));
